import { useQuery } from '@tanstack/react-query'

import { clientPortalApi } from '@/lib/api/client-portal.api'

export function useMyEntities() {
  return useQuery({
    queryKey: ['client-portal', 'my-entities'],
    queryFn: () => clientPortalApi.getMyEntities(),
    staleTime: 5 * 60_000,
    gcTime: 30 * 60_000,
  })
}
